const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab');
sectionTab[5].classList.add('sidebar-menu-container-section-tab--active');

const objContext = JSON.parse(sessionStorage.getItem("context"));
if(objContext == null || objContext.store_name == null)
    location.href='index.html';
var id_current_store = null, url_picture = null, objStoreInfo = null, selectedMenu = null, selectedCategory = null;

document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

// modal y contenedor de las tarjetas
const selectMenu = document.querySelector('#selectMenuImages'),
      selectCategories = document.querySelector('#selectCategoryImages'),
      modalMenu = document.querySelector('#modal'),
      modalContainer = document.querySelector('#modalContainer'),
      imgProduct = document.querySelector('.menu-product-img'),
      cancelModal = document.querySelector('#cancelModal'),
      saveModal = document.querySelector('#saveModal'),
      containerCardsProducts = document.querySelector('.cards-assign-container');

// tarjetas de los productos
let cardsProducts = document.querySelectorAll('.card-assign-product');


//layout de las tarjetas de productos
let layout = `
    <div class="card-assign-product" data-id="__ID__" onclick="openModalUpdate(this);">
        <div class="img-card-product">__PICTURE__</div>
        <div class="card-assign-product-container">
            <span class="category">__CATEGORY__</span>
            <span class="name">__NAME__</span>
        </div>
    </div>
`;

window.addEventListener("load", loadPage);
function loadPage(){
    id_current_store = localStorage.getItem("currentStore");
    UI.hideLoader();

    if(id_current_store == null || objContext == null)
        location.href='index.html';
    else {
        document.querySelector('.sidebar-profile-img img').src = objContext.store_image
        document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')

        loadStoreInfo();
    }
}

function loadStoreInfo(){
    UI.showLoader();

    fetch(
        BASE_URLS.Dinny.api + `/stores/${id_current_store}?req_id=${new Date().getTime()}`,
        {
          headers:{
            "Authorization": localStorage.getItem('session')
          }
        }
    ).then(function(response){
        if(response.ok){
            UI.hideLoader();
            selectMenuImages.innerHTML = '<option value="0" hidden="" selected="">Selecciona un menú</option>';

            response.json().then(function(json){
                console.log(json);
                objStoreInfo = json;

                if(objStoreInfo.menu && objStoreInfo.menu != null && objStoreInfo.menu.length > 0){
                    objStoreInfo.menu.forEach((element) => {
                        selectMenuImages.insertAdjacentHTML(
                            'beforeend',
                            `<option value='${element.id}'>${element.name}</option>`
                        )
                    });
                }else{
                    UI.message({ title: 'Datos incompletos', content: 'Para poder asignar imágenes es necesario que el establecimiento cuente al menos con un menú sincronizado con Dinny.<br/><br/>Por favor, crea un menú en tu administrador y sincronízalo con Dinny para que puedas asignar imágenes.', accept: 'Aceptar' }, function(){
                        location.href='index.html';
                    });
                    return;
                }

            });
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                  window.location.href = 'login.html'
                }else{
                    UI.hideLoader();
                    alert("Ocurrió un error al cargar los banners.", 'error')
                }
            })
        }
    }).catch(function(){ UI.hideLoader() });
}



function openModalUpdate(element){
    modalMenu.style.display = 'block';
    let elementIMG = element.querySelector('.img-card-product img');
    if(elementIMG != null){
        document.querySelector('.menu-product-img').innerHTML = '<img src="' + elementIMG.src + '" />';
    }
    document.querySelector('.modal-body-title').innerHTML = "Agregar la imagen del producto " + element.querySelector('span.name').innerHTML;
    saveModal.dataset.id = element.dataset.id;
}


// event listeners
selectMenu.addEventListener('change', (e) => {
    selectCategories.innerHTML = '<option value="0" hidden="" selected="">Selecciona una categoría</option>';
    if(selectMenu.value != "0"){
        selectedMenu = objStoreInfo.menu.find(x => x.id == selectMenu.value);
        if(selectedMenu != undefined){
            if(selectedMenu.categories && selectedMenu.categories != null && selectedMenu.categories.length > 0){
                selectedMenu.categories.forEach((element) => {
                    selectCategories.insertAdjacentHTML(
                        'beforeend',
                        `<option value='${element.id}'>${element.name}</option>`
                    )
                });

                document.getElementById('divCategoryImages').style = "display:flex";
            }
            else{
                document.getElementById('divCategoryImages').style = "display:none";
            }
        }
    }
});

selectCategories.addEventListener('change', (e) => {
    containerCardsProducts.innerHTML = "";

    if(selectCategories.value != "0"){
        selectedCategory = selectedMenu.categories.find(x => x.id == selectCategories.value);
        if(selectedCategory != undefined){
            if(selectedCategory.products && selectedCategory.products != null && selectedCategory.products.length > 0){
                selectedCategory.products.forEach((element) => {
                    containerCardsProducts.insertAdjacentHTML('beforeend',
                    layout
                        .replace('__ID__', element.id)
                        .replace('__CATEGORY__', selectCategories.options[selectCategories.selectedIndex].text)
                        .replace('__NAME__', element.name)
                        .replace('__PICTURE__', element.hasOwnProperty('thumbnail_image') && element.thumbnail_image.length > 0 ? '<img src="' + element.thumbnail_image + '" />' : ''));
                });

                document.getElementById('divCategoryImages').style = "display:flex";
            }
            else{
                document.getElementById('divCategoryImages').style = "display:none";
            }
        }
    }
});

var url_picture = null;
function previewPicture(e){
  url_picture = null;

  let outPut = document.querySelector('.menu-product-img');
  outPut.innerHTML = "";
  let outPutImage = document.createElement("img");
  outPutImage.src = URL.createObjectURL(e.target.files[0]);
  outPutImage.onload = function() {
      URL.revokeObjectURL(outPutImage.src) // free memory

      if(this.width >= 500 && this.height >= 500){
        if(e.target.files[0].size < 4096000)
          outPut.appendChild(outPutImage);
        else{
          UI.message({title: 'Error', content: 'Por favor, seleccione una imagen de menos de 4MB.', accept: 'Aceptar'});
          e.target.value = "";
        }
      }
      else{
        UI.message({title: 'Error', content: 'Por favor, seleccione una imagen de al menos 500x500 pixeles.', accept: 'Aceptar'});
        e.target.value = "";
      }
  }
}

saveModal.addEventListener('click', (e) => {
    let selectedImage = document.getElementById('product-img').files[0];

    if(selectedImage == null || selectedImage === "undefined")
    {
        UI.message({title: 'Faltan datos', content: 'Seleccione una imagen para el producto.', accept: 'Aceptar'});
        return;
    }

    let objIMG = {
        store_id: id_current_store,
        menu_id: selectMenu.value,
        category_id: selectCategories.value,
        product_id: saveModal.dataset.id,
        picture_url: null
    }

    UI.showLoader();

    let objReader = new FileReader();
    objReader.readAsDataURL(selectedImage);
    objReader.onload = function(e){
        let base64string = e.target.result;
        base64string = base64string.replace(base64string.substring(0, base64string.indexOf(',') + 1), "");

        fetch(
            BASE_URLS.Standalone.api + '/picture',
            {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({
                key: 'image/' + objIMG.store_id + '/' + objIMG.menu_id + '/product/' + new Date().toISOString().replace(/:/g, '').replace(/-/g, '').replace(/\./g, '') + '.' + selectedImage.name.split('.').pop(),
                content: base64string,
                contentType: selectedImage.type
            }),
            headers:{
                "Authorization": localStorage.getItem('session')
            }
        }).then(function(response){
            if(response.ok){
                response.json().then(function(picture_url){
                objIMG.picture_url = picture_url;
                console.log(objIMG);
                objIMG.is_vegan = document.getElementById('veganProduct').checked
                fetch(
                    BASE_URLS.Dinny.api + '/product-images/update',
                    {
                        method: 'POST',
                        mode: 'cors',
                        body: JSON.stringify(objIMG),
                        headers:{
                            "Authorization": localStorage.getItem('session')
                        }
                }).then(function(response){
                    UI.hideLoader();
                    if(response.ok){
                        document.querySelector('div.card-assign-product[data-id="' + objIMG.product_id + '"] div.img-card-product').innerHTML = '<img src="' + objIMG.picture_url + '" />';
                        selectedCategory.products.find(x => x.id == objIMG.product_id).thumbnail_image = objIMG.picture_url;
                        cancelModal.click();
                    }else{
                        UI.message({title: 'Ocurrió un error', content: 'No se pudo cambiar la imagen.', accept: 'Aceptar'});
                    }
                }).catch(function(error){
                    UI.hideLoader();
                    UI.message({title: 'Ocurrió un error', content: 'Ocurrió un error al cambiar la imagen.', accept: 'Aceptar'});
                    console.log(error);
                })
                });
            }else{
                response.json().then(function(content){
                    if(403 == response.status){
                        window.location.href = 'login.html'
                    }else{
                        UI.hideLoader();
                        UI.message({title: 'Ocurrió un error', content: 'Ocurrió un error al guardar la imagen.', accept: 'Aceptar'});
                    }
                });
            }
        }).catch(function(e){
            UI.hideLoader();
            UI.message({title: 'Ocurrió un error', content: 'Ocurrió un error al guardar la imagen.', accept: 'Aceptar'});
            console.log(e);
        });
    };
});

cancelModal.addEventListener("click", () =>{
    document.querySelector('.menu-product-img').innerHTML = "<img src='src/img/store/menu/product_default.png' />";
    document.getElementById('product-img').value = "";
    modalMenu.style.display = 'none';
    delete saveModal.dataset.id;
});